export default __webpack_public_path__ + "static/media/Sass.fd475502.png";